/* eslint-disable */
import { useState, useEffect } from "react";
import { ModalContext } from "./ModalContext";
import { isWalletConnected } from "../lib/metamaskhandler";
import { ethers } from "ethers";
import LAND_ABI from "../abi/LANDRegistry.json";

import { LAND_REGISTRY, NETWORK } from "./constants";

const ContextProvider = ({ children }) => {
  const [visibility, setVisibility] = useState(false);
  const [walletModalvisibility, setModalvisibility] = useState(false);
  const [shareModalVisibility, setShareModalvisibility] = useState(false);
  const [isPopup, setPopup] = useState(false);
  const [isPopupMetamask, setPopupMetamask] = useState(false);
  // popupError
  const [isPopupError, setPopupError] = useState(false);
  const [isBannerError, setBannerError] = useState(false);

  // totalSupply
  const [totalSupply, setTotalSupply] = useState(0);
  //meta mask
  const [metamaskModal, setMetamaskModal] = useState(false);
  const [networkModal, setNetworkModal] = useState(false);
  const [userAddress, setUserAddress] = useState(null);
  const [connect, setConnect] = useState(false);
  const [networkModalVisibility, setNetworkModalVisibility] = useState(false);
  const [loginModalVisibility, setLoginModalVisibility] = useState(false);
  const [checkoutModalVisibility, setCheckoutModalVisibility] = useState(false);
  const [network, setNetwork] = useState(NETWORK);

  useEffect(() => {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(
        window.ethereum,
        "any"
      );
      const signer = provider.getSigner();

      const contractLANDregistry = new ethers.Contract(
        LAND_REGISTRY,
        LAND_ABI,
        signer
      );

      const getTotalSupply = async () => {
        const getTotalSupplyTx = await contractLANDregistry.totalSupply();
        setTotalSupply(getTotalSupplyTx.toNumber());
        console.log("getTotalSupplyTx: ", getTotalSupplyTx.toNumber());
      };

      getTotalSupply();
    }
  }, []);

  const handleAccountConnect = (acc) => {
    setUserAddress(acc);
  };

  const closeLootModal = () => {
    setVisibility(false);
    window.location.reload(true);
  };

  const mintModalHandle = () => {
    setVisibility(!visibility);
  };
  // const loadingModalHandle = () => {
  //   setVisibility(!visibility);
  // };

  const mintSuccessModalHandle = () => {
    setVisibility(!visibility);
  };
  const walletModalHandle = () => {
    setModalvisibility(!walletModalvisibility);
  };
  const shareModalHandle = (e) => {
    e.preventDefault();
    setShareModalvisibility(!shareModalVisibility);
  };
  const popupHandle = () => {
    setPopup(!isPopup);
  };

  const popupMetamaskHandle = () => {
    setPopupMetamask(!isPopupMetamask);
  };

  const popupErrorHandle = () => {
    setPopupError(!isPopupError);
  };

  const popupBannerHandle = () => {
    setBannerError(!isBannerError);
  };

  const handleNetworkModal = () => {
    setNetworkModalVisibility(!networkModalVisibility);
    setNetworkModal(!networkModal);
  };

  const handleMetamaskModal = () => {
    setModalvisibility(!walletModalvisibility);
    setMetamaskModal(!metamaskModal);
  };

  const handleMetamaskInstalledModal = () => {
    setModalvisibility(false);
    setMetamaskModal(!metamaskModal);
  };

  const networkModalHandle = () => {
    setNetworkModalVisibility(!networkModalVisibility);
  };

  const openLoginModalHandle = () => {
    setLoginModalVisibility(true);
  };

  const closeLoginModalHandle = () => {
    setLoginModalVisibility(false);
  };

  const openCheckoutModalHandle = () => {
    setCheckoutModalVisibility(true);
  };

  const closeCheckouModalHandle = () => {
    setCheckoutModalVisibility(false);
  };

  return (
    <ModalContext.Provider
      value={{
        visibility,
        mintModalHandle,
        mintSuccessModalHandle,
        walletModalHandle,
        walletModalvisibility,
        networkModalVisibility,
        setNetworkModalVisibility,
        loginModalVisibility,
        setLoginModalVisibility,
        checkoutModalVisibility,
        openCheckoutModalHandle,
        openCheckoutModalHandle,
        openLoginModalHandle,
        closeLoginModalHandle,
        shareModalVisibility,
        shareModalHandle,
        isPopup,
        setPopup,
        isPopupMetamask,
        setPopupMetamask,
        popupHandle,
        popupMetamaskHandle,
        popupErrorHandle,
        metamaskModal,
        handleMetamaskModal,
        networkModalHandle,
        handleAccountConnect,
        handleNetworkModal,
        userAddress,
        setUserAddress,
        network,
        setNetwork,
        connect,
        setConnect,
        isPopupError,
        setPopupError,
        totalSupply,
        setTotalSupply,
        popupBannerHandle,
        closeLootModal,
        handleMetamaskInstalledModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ContextProvider;
